import styled from "styled-components";
import {
  Avatar,
  avatarUserTypes,
  colors,
  componentSizes,
  typography
} from "@streeteasy/design-system";

const { BRAND, NOTICE, NOTICE_LIGHTEST } = colors;
const { Caps } = typography;

export const AgentImage = styled(Avatar).attrs({
  alt: "",
  size: componentSizes.SM,
  userType: avatarUserTypes.PARTNER
})`
  border-radius: 50%;
  height: 65px;
  object-fit: cover;
  width: 65px;
`;

export const AgentDescriptionHeader = styled.div`
  display: flex;
  margin-bottom: 28px;
`;

export const AgentInfoContainer = styled.div`
  margin-left: 24px;
`;

export const ContactBuyersAgentButton = styled(Caps).attrs({
  as: "button"
})`
  background: 0;
  border: 0;
  color: ${BRAND};
  padding: 0;

  &:focus,
  &:hover {
    background-color: ${NOTICE_LIGHTEST};
    color: ${NOTICE};
    fill: ${NOTICE};
  }
`;
